import { useQuery } from '@apollo/client';
import { gql } from 'graphql-tag';

export const GetSmartFitResourceAvailabilityHoursOptionsByTotalHoursQuery = gql`
  query getSmartFitResourceAvailabilityHoursOptionsByTotalHoursQuery(
    $input: SmartFitResourceAvailabilityHoursOptionsByTotalHoursAndDateRangeInput!
  ) {
    smartFitResourceAvailabilityHoursOptionsByTotalHoursAndDateRange(
      input: $input
    ) {
      availableScheduleRulesWhatFits {
        dateRange {
          startDate: startDate2
          endDate: endDate2
        }
        do
      }
      extendAllocationScheduleRules {
        dateRange {
          startDate: startDate2
          endDate: endDate2
        }
        do
      }
      redistributeAllocationScheduleRules {
        dateRange {
          startDate: startDate2
          endDate: endDate2
        }
        do
      }
      allocateFullScheduleRules {
        dateRange {
          startDate: startDate2
          endDate: endDate2
        }
        do
      }
      redistributeHours
      extendedHours
      requestedHours
      allocateFullHours
      availableHoursWhatFits
      hasOverAllocatedPeriods
    }
  }
`;

const useGetSmartFitResourceAvailablityHoursOptionsByTotalHours = ({
  userUri,
  dateRange,
  hoursPerPeriod,
  periodType = 'ENTIRE_RANGE',
  skip = false
}) => {
  const { loading, error, data } = useQuery(
    GetSmartFitResourceAvailabilityHoursOptionsByTotalHoursQuery,
    {
      fetchPolicy: 'network-only',
      skip: skip || !dateRange || !hoursPerPeriod,
      variables: {
        input: {
          userUri,
          dateRange,
          hoursPerPeriod,
          periodType
        }
      }
    }
  );

  return {
    isLoading: loading,
    smartFitmentDetails:
      data?.smartFitResourceAvailabilityHoursOptionsByTotalHoursAndDateRange,
    error
  };
};

export default useGetSmartFitResourceAvailablityHoursOptionsByTotalHours;
